'use client';

import React from 'react';
import { ArrowLeftIcon, HomeIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';

interface NotFoundCopy {
  title: string;
  message: string;
  goBack: string;
  backHome: string;
}

interface NotFoundClientProps {
  copy: NotFoundCopy;
  homeHref: string;
}

export default function NotFoundClient({ copy, homeHref }: NotFoundClientProps) {
  const handleGoBack = () => {
    if (typeof window !== 'undefined') {
      window.history?.back();
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <div className="relative">
            <h1 className="text-9xl font-bold text-primary opacity-20">404</h1>
          </div>
        </div>

        <h2 className="text-2xl font-medium text-onBackground mb-2">{copy.title}</h2>
        <p className="text-onBackground/70 mb-8">{copy.message}</p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={handleGoBack}
            className="inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-lg font-medium hover:bg-primary/90 transition-colors duration-200"
          >
            <ArrowLeftIcon width={16} height={16} aria-hidden="true" />
            {copy.goBack}
          </button>

          <Link
            href={homeHref}
            className="inline-flex items-center justify-center gap-2 border border-border bg-background text-foreground px-6 py-3 rounded-lg font-medium hover:bg-accent hover:text-accent-foreground transition-colors duration-200"
          >
            <HomeIcon width={16} height={16} aria-hidden="true" />
            {copy.backHome}
          </Link>
        </div>
      </div>
    </div>
  );
}
